import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, Router } from "@tanstack/react-location";
import { lazy, Suspense } from "react";
import Home from "./Home";
import Create from "./Create";
import Proposal from "./Proposal";
import Header from "../components/Header";
import Layout from "../components/Layout";
import LoadingState from "../components/LoadingState";
import { EPATHS } from "../constants/paths";
const AppRoutes = [
    {
        id: "home",
        path: EPATHS.PROPOSAL_OVERVIEW,
        element: _jsx(Home, {}),
        loader: () => {
            return {
                align: "center",
            };
        },
    },
    {
        id: "create",
        path: EPATHS.CREATE_PROPOSAL,
        element: _jsx(Create, {}),
    },
    {
        id: "proposal",
        path: EPATHS.PROPOSAL_DETAIL,
        element: _jsx(Proposal, {}),
    },
];
const ReactLocationDevtools = process.env.NODE_ENV === "production"
    ? () => null
    : lazy(() => import("@tanstack/react-location-devtools").then(({ ReactLocationDevtools }) => ({
        default: ReactLocationDevtools,
    })));
export const Routes = ({ location, routes = [] }) => {
    const fullRoutes = [...AppRoutes, ...routes];
    return (_jsxs(Router, { useErrorBoundary: true, location: location, routes: fullRoutes, children: [_jsx(Header, {}), _jsxs(Layout, { children: [_jsx(Suspense, { fallback: _jsx(LoadingState, {}), children: _jsx(Outlet, {}) }), _jsx(ReactLocationDevtools, { position: "bottom-right" })] })] }));
};
//# sourceMappingURL=RouteProvider.js.map